import Cookies from 'universal-cookie';

const cookies = new Cookies();
const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;

class Storage {
  setItem(key: string, value: string) {
    try {
      localStorage.setItem(key, value);
    } catch (err) {
      const expires = Date.now() + ONE_YEAR;

      cookies.set(key, value, {
        expires: new Date(expires),
        path: '/'
      });
    }
  }

  getItem(key: string): string {
    let value = '';

    try {
      value = localStorage.getItem(key) || '';
    } catch (err) {
      value = cookies.get(key);
    }

    return value;
  }

  removeItem(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      cookies.remove(key);
    }
  }
}

export const storage = new Storage();
